export { LoyaltyPoints } from './loyalty-points';
